import { Platform } from 'react-native';
import { tv } from '@/common/theme/tv.config';

export const styles = tv({
  slots: {
    root: [
      'h-[2.4rem] w-[4rem] rounded-[3rem] p-[0.1rem]',
      Platform.OS === 'web' ? 'cursor-pointer' : '',
    ],
    thumbWrapper: 'h-[2.2rem] w-[2.2rem]',
    thumb: [
      'h-[2.2rem] w-[2.2rem] items-center justify-center rounded-full bg-neutral10',
      Platform.OS === 'web' ? 'transition-transform duration-200' : '',
    ],
  },
  variants: {
    checked: {
      true: {
        root: 'bg-accentPrimary40',
        thumb: Platform.OS === 'web' ? 'translate-x-[1.6rem]' : '',
      },
      false: {
        root: 'bg-neutral40',
        thumb: Platform.OS === 'web' ? 'translate-x-0' : '',
      },
    },
    disabled: {
      true: {
        root: 'bg-neutral30',
      },
    },
  },
})();
